import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfileIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.66602 12.534C2.66602 10.7666 4.0987 9.33398 5.86602 9.33398H10.1327C11.9 9.33398 13.3327 10.7666 13.3327 12.534C13.3327 13.7122 12.3775 14.6673 11.1993 14.6673H4.79935C3.62114 14.6673 2.66602 13.7122 2.66602 12.534Z",
		stroke: "#EFEEF0",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.666 4.00065C10.666 5.47341 9.47208 6.66732 7.99935 6.66732C6.52659 6.66732 5.33268 5.47341 5.33268 4.00065C5.33268 2.52789 6.52659 1.33398 7.99935 1.33398C9.47208 1.33398 10.666 2.52789 10.666 4.00065Z",
		stroke: "#EFEEF0",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgProfileIcon;
